export default __webpack_public_path__ + "static/media/portrait1.74e7a095.png";